import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../config";
import { generateCorrelationId } from "../utils/helpers";
import formatDashboardData from "../models/DashboardData";

export const dashboardApi = createApi({
    reducerPath: "dashboardApi",
    baseQuery: fetchBaseQuery({
        baseUrl: config.REACT_APP_API_URL,
        credentials: "include",
        prepareHeaders: (headers) => {
            headers.set("Accept", "application/json");
            headers.set("Content-Type", "application/json");

            const apiKey = process.env.REACT_APP_API_KEY;
            if (apiKey) {
                headers.set("apikey", apiKey);
            }

            const correlationId = generateCorrelationId();
            if (correlationId) {
                headers.set("x-unum-correlation-id", correlationId);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        getDisabilityComparisons: builder.query({
            query: ({
                organizationIds,
                policyDivisions,
                claimStatuses,
                reportingGroups,
                leaveStatuses,
                coverageTypes,
                sicCodes,
                pflClaimExclude,
                startYear,
                startQuarter,
                endYear,
                endQuarter,
                compareTypes,
                groupBy,
            }) => {
                const isLeaveCoverage = coverageTypes?.includes("Leave");
                const reportPath = isLeaveCoverage
                    ? "leave-comparison-reports"
                    : "disability-comparison-reports";
                return {
                    url: `/dashboards/${process.env.REACT_APP_API_VERSION}/${reportPath}${config.REACT_APP_ENV_NAME}`,
                    method: "POST",
                    body: {
                        organizationIds,
                        ...(isLeaveCoverage
                            ? { reportingGroups, leaveStatuses }
                            : { policyDivisions, claimStatuses }),
                        coverageTypes,
                        sicCodes,
                        pflClaimExclude,
                        startYear:
                            startYear == null ? startYear : String(startYear),
                        startQuarter,

                        endYear: endYear == null ? endYear : String(endYear),
                        endQuarter,
                        compareTypes,
                        groupBy,
                    },
                };
            },
            transformResponse: (response) => {
                const formattedCharts = formatDashboardData(response); // ✅ USE FUNCTION
                return {
                    ...response,
                    formattedCharts,
                };
            },
        }),
    }),
});

export const { useLazyGetDisabilityComparisonsQuery } = dashboardApi;
